import { Settings, Database, Zap } from "lucide-react";
import { NichePage } from "./NichePageTemplate";

const sections = [
  {
    icon: Settings,
    name: "Executive Operations",
    items: [
      "Administrative coordination", "Information organization", "Research",
      "Task management", "Project coordination", "Documentation", "Follow-up"
    ]
  },
  {
    icon: Database,
    name: "Business Systems",
    items: [
      "CRM organization", "Workflow design", "Process documentation",
      "Systems coordination", "Automation"
    ]
  },
  {
    icon: Zap,
    name: "Operational Management",
    items: [
      "Process tracking", "Internal coordination", "Reporting",
      "SOP development", "Recurring workflow management"
    ]
  }
];

export const CEOOperationsPage = () => (
  <NichePage
    title="CEO & Executive Operations"
    subtitle="Operational structure for leaders who need systems that keep the business moving."
    sections={sections}
  />
);
